export const getImage = (imageIds) => {
  return null;
};

export const getImageV2 = (imageId) => {
  // todo remove
  return `https://app.bimclinics.ru/images/g:sm/rs:fill:1000:1000/plain/local:///${imageId}.jpg`;
  // return `/images/g:sm/rs:fill:1000:1000/plain/local:///${imageId}.jpg`;
};

export const getImageV3 = (imageId, size) => {
  // todo remove
  return `https://app.bimclinics.ru/images/g:sm/rs:fill:${size ? size : "1000:1000"}/plain/local:///${imageId}.jpg`;
  // return `/images/g:sm/rs:fill:${size ? size : '1000:1000'}/plain/local:///${imageId}.jpg`;
};

export default getImage;
